
const initialState = {
    auctions: [],
    newAuction: {},
    lotDetails: []
};

const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return { ...state, token: action.payload };
        case 'SAVE_AUCTION':
            return { ...state, newAuction: action.payload };
        case 'GET_AUCTIONS':
            return { ...state, auctions: action.payload };
        case 'GET_LOT_DETAILS':
            return { ...state, lotDetails: action.payload };
        default:
            return state;
    }
};
export default adminReducer;